import React, { useContext, useCallback, useState } from 'react'
import { ExpContext } from 'src/providers/experimentation'

const defaultConsoleWarn = () => {
  console.warn('Amplitude not configured, cannot track event.')
}

export const useEditLoanCtaHigherInDigestExp = () => {
  let expIsActive = false
  const { amplitude, experiment, expUserId } = useContext(ExpContext)
  const [firedTracks, setFiredTracks] = useState({
    ['track-EditLoanCta-ScrollIntoView']: false,
    ['track-EditLoanCta-MouseOver']: false,
    ['track-EditLoanCta-CtaClick']: false,
  })

  if (experiment && experiment.variant) {
    expIsActive =
      experiment.variant('edit-loan-cta-higher-in-digest').value === 'treatment'
  }

  const logEventOnce = useCallback(
    eventName => {
      if (!amplitude) {
        defaultConsoleWarn()
      } else {
        if (!firedTracks[eventName]) {
          amplitude.logEvent(eventName)
          setFiredTracks({
            ...firedTracks,
            [eventName]: true,
          })
        }
      }

      return () => setFiredTracks({
        ['track-EditLoanCta-ScrollIntoView']: false,
        ['track-EditLoanCta-MouseOver']: false,
        ['track-EditLoanCta-CtaClick']: false,
      })
    },
    [firedTracks, amplitude, expUserId]
  )

  return {
    active: expIsActive,
    trackScrolledIntoView: () => logEventOnce('track-EditLoanCta-ScrollIntoView'),
    trackMouseOver: () => logEventOnce('track-EditLoanCta-MouseOver'),
    trackCtaClick: () => logEventOnce('track-EditLoanCta-CtaClick'),
  }
}
